import type { PersonDto } from '@api/swagger/definitions/backoffice'
import type { PersonAuthResponse } from '@mynt/backoffice-api-spec/auth-person'
import type { AuthPersonInfo, Person } from '../types'

export const mapPersonAuthResponseToAuthPersonInfo = (dto: PersonAuthResponse): AuthPersonInfo => ({
  recoveryEmail: dto.recoveryEmail,
  recoveryPhoneNumber: dto.recoveryPhoneNumber,
  usesBankId: dto.usesBankId,
  usesPasskey: dto.usesPasskey,
  usesEmailPassword: dto.usesEmailPassword,
  identityDomain: dto.identityDomain,
  persons: dto.persons,
})

export const mapPersonDtoToPerson = (dto: PersonDto): Person => ({
  log: dto.log,
  id: dto.id,
  rev: dto.rev,
  deleted: dto.deleted,
  fullName: dto.fullName,
  inviteSentAt: dto.inviteSentAt,
  ssn: dto.ssn,
  roles: dto.roles as unknown[],
  peEmployeeId: dto.peEmployeeId,
  findityEmployeeId: dto.findityEmployeeId,
  blPersonExternalId: dto.blPersonExternalId,
  partnerExternalId: dto.partnerExternalId,
  enfuceCustomerId: dto.enfuceCustomerId,
  customerId: dto.customerId,
  authPersonId: dto.authPersonId,
  phoneNumber: dto.phoneNumber,
  email: dto.email,
  modifiedAt: dto.modifiedAt,
})
